module.exports = __webpack_public_path__ + "img/SketchPng4584ee5f51cd0024e9dac6ba0be6a65efc085aadb99ace0eab9fda86498461ad.ba1fe85c.png";